import type { ApiFetch } from '@versesverse/core';

/**
 * The platform `fetch`, presented as core's `ApiFetch`.
 *
 * core keeps its fetch abstraction DOM-free — its `signal` is `unknown`, because core compiles
 * without the DOM library and must run in Node and React Native too. So the bridge NARROWS the
 * signal with an `instanceof` rather than a cast (a cast here would be a lie the moment core
 * passed something that was not an AbortSignal), and hands `fetch` a `RequestInit` built by hand.
 * A `Response` already satisfies core's `ApiResponse` structurally, so nothing is needed on the
 * way back.
 */
export const browserFetch: ApiFetch = (url, init) =>
  fetch(url, init && {
    /* EVERY FIELD, not the ones this file happens to know about. Built by hand it dropped
       `method`, `body` and `credentials`, which turned every social write into a GET — see
       `ApiRequestInit`. Listed rather than spread so the narrowing of `signal` below stays
       explicit, and so a field added to the init fails to compile here until somebody decides
       what a browser should do with it. */
    method: init.method,
    body: init.body,
    credentials: init.credentials,
    headers: init.headers,
    signal: init.signal instanceof AbortSignal ? init.signal : undefined,
  });
